import Banner1 from "../../media/banner carousel/banner (1).webp";
import Banner2 from "../../media/banner carousel/banner (2).webp";
import Banner3 from "../../media/banner carousel/banner (3).webp";
import Banner4 from "../../media/banner carousel/banner (4).webp";

const bannerimages = [Banner1, Banner2, Banner3, Banner4];

export default bannerimages;
